// extracted by mini-css-extract-plugin
module.exports = {"contact":"Contact_contact__md4vV","background":"Contact_background__Te2Hn","contactText":"Contact_contactText__36mLg"};